import { render, staticRenderFns } from "./sendInvite.vue?vue&type=template&id=da995496&scoped=true"
import script from "./sendInvite.vue?vue&type=script&lang=js"
export * from "./sendInvite.vue?vue&type=script&lang=js"
import style0 from "./sendInvite.vue?vue&type=style&index=0&id=da995496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da995496",
  null
  
)

export default component.exports